import { useState } from 'react';
import { TEInput } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
import type { DefaultOptionType } from '@timeedit/ui-components/antd/select/index';
import SizeSpans from '../components/SizeSpans';
import type { TReportTemplateProps } from './ReportTemplate';

type TDemandSizeSettings = TReportTemplateProps & {
  sizeFieldOptions: DefaultOptionType[];
};

const DemandSizeSettings = ({
  data,
  onChange,
  sizeFieldOptions,
}: TDemandSizeSettings) => {
  const [calculateDemandSize, setCalculateDemandSize] = useState(
    !!data.demandFieldExtId
  );

  return (
    <Space direction="vertical">
      <TEInput.Switch
        label="Calculate size demand"
        tooltip="If enabled, demand will be calculated based on size spans"
        value={calculateDemandSize}
        onChange={(val) => {
          setCalculateDemandSize(val);
          if (!val) {
            onChange('demandFieldExtId', null);
          }
        }}
      />
      {calculateDemandSize && (
        <>
          <TEInput.Select
            label="Size field"
            tooltip="Field that contains the size of target object"
            value={data.demandFieldExtId}
            options={sizeFieldOptions}
            onChange={(val) => onChange('demandFieldExtId', val)}
          />
          <SizeSpans
            value={data.demandSizeSpans || []}
            onChange={(val) => onChange('demandSizeSpans', val)}
          />
        </>
      )}
    </Space>
  );
};

export default DemandSizeSettings;
